<template>
    <div
        v-if="dynamicComponents"
        class="o-main-frame"
    >
        <template
            v-for="item in dynamicComponents"
        >
            <component
                :is="item"
                :key="item"
                :view="view"
            />
        </template>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: "OMainFrame",
    components: {
        AHomeButton: () => import('../../atoms/a-home-button'),
        OStartTiles: () => import('../../unique-organisms/o-start'),
        OGuideSidebar: () => import('../../organisms/o-guide-sidebar'),
        OMovieDetails: () => import('../../organisms/o-movie-details'),
        OVideoShopGrid: () => import('../../organisms/o-videoshop-grid'),
        OTransportSchedule: () => import('../../organisms/o-t-transport'),
        OGuideSidebarSK: () => import('../../organisms/o-guide-sidebar-sk'),
        OGuideSidebarOtg: () => import('../../organisms/o-guide-sidebar-otg'),
        OOtgStartTiles: () => import('../../unique-organisms/o-otg-start-tiles'),
        OTilesGridWithScroll: () => import('../../organisms/o-tiles-grid-with-scroll'),
        OLanguageSelector: () => import('../../organisms/o-language-selector/o-language-selector')
    },
    props: {
        view: {
            type: String,
            default: ''
        }
    },
    computed: {
        ...mapGetters([
            'getMapConfigProp'
        ]),
        dynamicComponents() {
            return Object.keys(this.getMapConfigProp(`views.${this.view}.mainFrame`)).reverse() || null;
        }
    }
  
}
</script>

<style lang="scss" src="./o-main-frame.scss" />
